import { SagaGenerator, select } from 'typed-redux-saga';

import { DisconnectPayload, DisconnectReason } from '../../../pages/call/types';
import { ErrorPageType } from '../../components/error-page/types';
import { cloudApi } from '../../helpers/transport';
import { getConfig, isRoomAgentMode, selectErrorPageType } from '../config/selectors';
import { HaltReason } from './constants';
import { HaltDescriptor } from './types';

export function* setRoomAgentToken(): SagaGenerator<void> {
    const { roomAgent } = yield* select(getConfig);

    if (roomAgent && !roomAgent.dropHeader) {
        const tokenHeaderName = 'X-Telemost-Meeting-Room-Agent-Token';
        cloudApi.setHeader(tokenHeaderName, roomAgent.token);
    }
}

export function mapConfPayloadToHaltDescriptor(payload: DisconnectPayload): HaltDescriptor {
    const reason = (() => {
        switch (payload.source) {
            case DisconnectReason.UNAUTHORIZED:
                return HaltReason.ACCESS_FORBIDDEN;
            default:
                return HaltReason.UNKNOWN_ERROR;
        }
    })();

    return {
        reason,
        description: payload.error?.description,
    };
}

export function* ensurePageLoadedSaga() {
    if (!(yield* select(isRoomAgentMode))) {
        return;
    }

    const errorPageType = yield* select(selectErrorPageType);

    if (!errorPageType) {
        return;
    }

    const reason = (() => {
        switch (errorPageType) {
            case ErrorPageType.USER_KECKED:
            case ErrorPageType.USER_KICKED_WITH_BAN:
            case ErrorPageType.UNAUTHORIZED:
            case ErrorPageType.FORBIDDEN:
            case ErrorPageType.ORGANIZATION_MISMATCHES:
                return HaltReason.ACCESS_FORBIDDEN;
            case ErrorPageType.NOT_FOUND:
                return HaltReason.INVALID_MEETING_ROOM_NUMBER;
            default:
                return HaltReason.UNKNOWN_ERROR;
        }
    })();

    global.window?.ROOM_AGENT_halt({
        reason,
        description: `telemost open error ${errorPageType}`,
    });
}
